import { render, staticRenderFns } from "./addPotentialClient.vue?vue&type=template&id=015a8d53&scoped=true&"
import script from "./addPotentialClient.vue?vue&type=script&lang=js&"
export * from "./addPotentialClient.vue?vue&type=script&lang=js&"
import style0 from "./addPotentialClient.vue?vue&type=style&index=0&id=015a8d53&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a8d53",
  null
  
)

export default component.exports